import React from 'react';
import { PageWrapper } from '@jelly/components';
import { AdvertisingDisclosure } from '../TopFiveQT/AdvertisingDisclosure';
import Header from './Header';
import Footer from './Footer';
export function TemplateWrapper(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/React.createElement(PageWrapper, {
    meta: meta
  }, /*#__PURE__*/React.createElement(AdvertisingDisclosure, null), /*#__PURE__*/React.createElement(Header, null), children, /*#__PURE__*/React.createElement(Footer, null));
}